import { render, staticRenderFns } from "./SliderFour.vue?vue&type=template&id=f8b4562c&scoped=true&"
import script from "./SliderFour.vue?vue&type=script&lang=js&"
export * from "./SliderFour.vue?vue&type=script&lang=js&"
import style0 from "./SliderFour.vue?vue&type=style&index=0&id=f8b4562c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b4562c",
  null
  
)

export default component.exports